export const products = [

    {
        id:1, 
        name:'PKNERGY Powerwall 48V 100Ah 5Kwh Batería LiFePO4 de montaje en pared Almacenamiento de energía en el hogar',
        description: `Nombre del producto: Batería Powerwall LiFePO4 de 48V 100Ah 5kwh,
        Solicitud: Hogar,
        Tipo de Batería: LiFePO4,
        Voltaje: 48V,
        Capacidad: 100Ah,
        Tipo de controlador: MPPT,
        Tiempo de trabajo (horas): 24 horas,
        Certificado: CE, UN38.3, MSDS,IEC/ISO9001/ISO1400,
        Dimensión: 680*480*180mm,
        Ciclo de vida: 5000 veces al 80% DOD,
        Tipo de célula: Célula de batería prismática Lifepo4 de 3.2v 100ah`,
        category: 1,
        image: 'https://cdnus.globalso.com/pknergy/PKNERGY-51.2V-100Ah-200AH-Powerwall-LiFePO4-Battery163.jpg'
    },
    { 
        id:2,
        name:'PKNERGY 48V 200Ah 10Kwh Batería LiFePO4 de montaje en pared para almacenamiento de energía en el hogar',
        description: `Nombre del producto:Batería Powerwall de 48V 200Ah 10kwh,
        Solicitud:Hogar,
        Tipo de Batería:LiFePO4,
        Voltaje:48V,
        Capacidad:200Ah,
        Tipo de controlador:MPPT,
        Tiempo de trabajo (horas):24 horas,
        Certificado:CE, UN38.3, MSDS,IEC/ISO9001/ISO1400,
        Dimensión:680*480*180mm,
        Ciclo de vida:5000 veces al 80% DOD,
        Tipo de célula:Célula de batería prismática Lifepo4 de 3.2v 100ah`,
        category: 1,
        image: 'https://www.pknergy.com/uploads/48V-100Ah-200Ah-Wall-Mounted-LiFePO4-Battery-8.jpg'
    },
    { 
        id:3,
        name:'PKNERGY 48V 100Ah 5Kwh Batería LiFePO4 de montaje en pared con rodillo',
        description: `Nombre del producto:Batería Powerwall LiFePO4 de 48V 100Ah 5kwh,
        Solicitud:Hogar,
        Tipo de Batería:LiFePO4,
        Voltaje:48V,
        Capacidad:100Ah,
        Tipo de controlador:MPPT,
        Tiempo de trabajo (horas):24 horas,
        Certificado:CE, UN38.3, MSDS,IEC/ISO9001/ISO1400,
        Dimensión:680*480*180mm,
        Ciclo de vida:5000 veces al 80% DOD,
        Tipo de célula:Célula de batería prismática Lifepo4 de 3.2v 100ah`,
        category: 1,
        image: 'https://www.pknergy.com/uploads/PKNERGY-Powerwall-48V-100Ah-10Kwh-Wall-Mount-LiFePO4-Battery-with-Roller-6.jpg'
    },
    { 
        id:4,
        name:'China Batería Lifepo4 montada en bastidor de 48V 50AH Fabricantes',
        description: `Tipo de Batería: Batería de fosfato de iones de litio,
        Marca: PKNERGY,
        Tensión nomina: l48,
        Capacidad: 50Ah,
        Tamaño: (mm) / Tamaño (pulgadas) L*W*H 442*385*132/ 17,40*15,16*5,20,
        Peso: 35,5 kg/78,26 libras,
        Solicitud Sistema solar de respaldo fuera de la red, inversor solar híbrido UPS, Telecom UPS,
        Paquete caja de polimadera`,
        category: 2,
        image: 'https://www.pknergy.com/uploads/48V-50AH-Rack-Mounted-Lifepo4-Battery-China-Manufacturer-1-300x300.jpg'
    },
    { 
        id:5,
        name:'módulo de la batería de 5U 48V 51.2V 100Ah Lifepo4 para la estación base del sistema solar',
        description: `Product name: 48V 100Ah 5kwh Powerwall LiFePO4 Battery 
            Application: Home \n
            Battery Type: LiFePO4 \n
            Voltage：48V \n
            Capacity：100Ah \n
            Controller Type: MPPT \n
            Work Time (h): 24 hours \n
            Certificate: CE, UN38.3, MSDS,IEC/ISO9001/ISO1400 \n
            Dimension: 680*480*180mm \n
            Cycle life: Over 6000 times \n 
            Cell type: 3.2v 100ah Lifepo4 Prismastic battery Cell \n`,
        category: 2,
        image: 'https://www.pknergy.com/uploads/5U-48V-51.2V-100Ah-Lifepo4-Battery-Pack-Module-for-Solar-System-Base-Station-1-300x300.jpg'
    },
    { 
        id:6,
        name:'PKNERGY 12V 10Ah LiFePo4 Reemplazo de batería de plomo ácido',
        description: `Las baterías LiFePO4 están diseñadas para reemplazar las baterías de plomo ácido y proporcionar un rendimiento sostenido sobresaliente y una salida de energía total. Esta batería de plomo ácido de reemplazo LiFePo4 de 12V 100Ah.Absolutamente perfecto para energía portátil y reemplazo de batería de plomo ácido / AGM de capacidad similar.`,
        category: 3,
        image: 'https://www.pknergy.com/uploads/12V-10Ah-Lithium-Replacing-Lead-Acid-Battery-1.jpg'
    },
    { 
        id:7,
        name:'PKNERGY 12V 50Ah LiFePo4 Reemplazo de batería de plomo ácido',
        description: `Las baterías LiFePO4 están diseñadas para reemplazar las baterías de plomo ácido y proporcionar un rendimiento sostenido sobresaliente y una salida de energía total. Esta batería de plomo ácido de reemplazo LiFePo4 de 12V 100Ah.Absolutamente perfecto para energía portátil y reemplazo de batería de plomo ácido / AGM de capacidad similar.`,
        category: 3,
        image: 'https://www.pknergy.com/uploads/12V-50Ah-Lithium-Replacing-Lead-Acid-Battery-4.jpg'
    },
    { 
        id:8,
        name:'PKNERGY 12V 200Ah LiFePo4 Reemplazo de batería de plomo ácido',
        description: `Las baterías LiFePO4 de s están diseñadas para reemplazar las baterías de plomo-ácido y proporcionar un rendimiento sostenido sobresaliente y una salida de energía total. Esta batería de plomo-ácido de reemplazo LiFePo4 de 12V 100Ah.Absolutamente perfecto para energía portátil y reemplazo de batería de plomo ácido / AGM de capacidad similar. Es ampliamente utilizado en EV de baja velocidad, carrito de golf, automóvil limpio, RV Marine y Boat, etc.`,
        category: 3,
        image: 'https://www.pknergy.com/uploads/12V-150-Ah-LiFePo4-Replacing-Lead-Acid-Battery-21.jpg'
    },
    { 
        id:9,
        name:'Paquete de batería de iones de litio PKNERGY 18650 - 3.7V 4400mAh Personalizado',
        description: `¡Este paquete de iones de litio está hecho de 2 celdas balanceadas de 2200 mAh para una capacidad total de 4400 mA!Las celdas están conectadas en paralelo y soldadas por puntos a un circuito de protección que proporciona protección contra sobrevoltaje, bajo voltaje y sobrecorriente.`,
        category: 4,
        image: 'https://www.pknergy.com/uploads/3.7V-4400mAh.jpg'
    },
    { 
        id:10,
        name:'Paquete de batería de iones de litio PKNERGY 18650 - 3.7V 6600mAh Personalizado',
        description: `¿Necesita una batería enorme para su proyecto?¡Este paquete de iones de litio está hecho de 3 celdas balanceadas de 2200 mAh para una capacidad total de 6600 mA!Las celdas están conectadas en paralelo y soldadas por puntos a un circuito de protección que proporciona protección contra sobrevoltaje, bajo voltaje y sobrecorriente.`,
        category: 4,
        image: 'https://www.pknergy.com/uploads/3.7V-6600mAh-21.jpg'
    },
    { 
        id:11,
        name:'Batería de iones de litio PKNERGY - 3.7V 10050mAh (10 Ah)',
        description: `Las baterías de iones de litio son delgadas, livianas y potentes.La salida varía de 4,2 V cuando está completamente cargada a 3,7 V.Esta batería tiene una capacidad de 10.050 mAh (también conocida como 10 Ah) para un total de unos 37 Wh.Si no necesita tanta energía, también tenemos varias variaciones de mAh de LiPos.`,
        category: 4,
        image: 'https://www.pknergy.com/uploads/18650-Battery-2.jpg'
    },
    { 
        id:12,
        name:'Batería de iones de litio personalizada PKNERGY 10400 14430 14500 14650 16340 18350 18500',
        description: `PKNERGY personalizó todo tipo de modelo y capacidad de batería de iones de litio 10400 14430 14500 14650 16340 18350 18500, etc., de acuerdo con sus requisitos personalizados para usted.`,
        category: 4,
        image: 'https://www.pknergy.com/uploads/18650-Battery2.jpg'
    },
    { 
        id:13,
        name:'Paquete de batería de iones de litio PKNERGY personalizado 18500 3.7V 1200mAh-1400mAh',
        description: `¡Este paquete de iones de litio está hecho de 2 celdas balanceadas de 2200 mAh para una capacidad total de 4400 mA!Las celdas están conectadas en paralelo y soldadas por puntos a un circuito de protección que proporciona protección contra sobrevoltaje, bajo voltaje y sobrecorriente.`,
        category: 4,
        image: 'https://www.pknergy.com/uploads/18500mAh-Battery.jpg'
    },

]